<nav class="navbar navigation-container fixed-top">
  <span class="logo">
    <a routerLink="/">
      <img src="../../../assets/images/ezylogo.png" class="logo-image" />
    </a>
  </span>
  <ul class="nav justify-content-end ">
    <li class="nav-item ">
      <a class="nav-link active text-white" routerLink="/">Home</a>
    </li>
    <li class="nav-item">
      <a class="nav-link text-white" routerLink="/about">About</a>
    </li>
    <li class="nav-item">
      <a class="nav-link text-white" routerLink="/contact">Contact</a>
    </li>
  </ul>
</nav>
